var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512.002,
    height: 512.002,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 402,
    width: 582,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    id: "svg_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_3",
    fill: "#FFFFFF",
    d: "m504.5,248.501l-120.758,0l0,-17.064l32.581,0c4.142,0 7.5,-3.358 7.5,-7.5c0,-4.142 -3.358,-7.5 -7.5,-7.5l-32.581,0l0,-17.065l22.62,0c8.427,0 16.35,-3.281 22.308,-9.24l49.326,-49.326c3.214,1.601 6.777,2.453 10.473,2.453c6.286,0 12.195,-2.448 16.64,-6.892c4.445,-4.445 6.893,-10.354 6.893,-16.64c0,-6.286 -2.448,-12.195 -6.893,-16.64c-4.444,-4.445 -10.354,-6.893 -16.64,-6.893s-12.195,2.448 -16.64,6.892c-4.445,4.445 -6.893,10.354 -6.893,16.64c0,3.696 0.852,7.259 2.453,10.473l-49.326,49.326c-3.125,3.125 -7.281,4.847 -11.702,4.847l-22.62,0l0,-16.548c0,-21.816 -17.749,-39.564 -39.564,-39.564l-16.548,0l0,-66.395c9.308,-3.139 16.032,-11.946 16.032,-22.3c0,-12.976 -10.557,-23.532 -23.532,-23.532c-12.975,0 -23.532,10.557 -23.532,23.532c0,10.354 6.724,19.16 16.032,22.3l0,66.394l-17.064,0l0,-32.581c0,-4.142 -3.358,-7.5 -7.5,-7.5c-4.142,0 -7.5,3.358 -7.5,7.5l0,32.581l-17.065,0l0,-120.758c0,-4.142 -3.358,-7.5 -7.5,-7.5c-4.142,0 -7.5,3.358 -7.5,7.5l0,120.758l-17.064,0l0,-32.581c0,-4.142 -3.358,-7.5 -7.5,-7.5c-4.142,0 -7.5,3.358 -7.5,7.5l0,32.581l-17.064,0l0,-22.619c0,-8.427 -3.282,-16.35 -9.241,-22.308l-49.343,-49.343c4.359,-8.801 2.898,-19.775 -4.421,-27.095c-9.176,-9.175 -24.105,-9.174 -33.28,0c-9.175,9.175 -9.175,24.104 0,33.28c4.588,4.587 10.614,6.881 16.64,6.881c3.588,0 7.17,-0.833 10.455,-2.46l49.343,49.344c3.126,3.125 4.847,7.281 4.847,11.701l0,22.619l-16.548,0c-3.345,0 -6.672,0.42 -9.888,1.247c-4.011,1.032 -6.426,5.121 -5.394,9.133c1.032,4.012 5.122,6.427 9.133,5.394c1.995,-0.513 4.063,-0.774 6.148,-0.774l176.354,0c13.545,0 24.564,11.02 24.564,24.564l0,176.355c0,2.083 -0.26,4.15 -0.772,6.143c-1.031,4.012 1.385,8.1 5.396,9.131c0.626,0.161 1.254,0.238 1.873,0.238c3.341,0 6.388,-2.249 7.258,-5.635c0.826,-3.212 1.245,-6.536 1.245,-9.878l0,-16.548l66.394,0c3.139,9.308 11.946,16.032 22.3,16.032c12.976,0 23.532,-10.556 23.532,-23.532s-10.557,-23.532 -23.532,-23.532c-10.354,0 -19.16,6.724 -22.3,16.032l-66.394,0l0,-17.065l32.581,0c4.142,0 7.5,-3.358 7.5,-7.5c0,-4.142 -3.358,-7.5 -7.5,-7.5l-32.581,0l0,-17.063l120.759,0c4.142,0 7.5,-3.358 7.5,-7.5c0,-4.142 -3.358,-7.5 -7.5,-7.5zm-22.065,-134.807c1.612,-1.612 3.754,-2.499 6.033,-2.499s4.421,0.887 6.033,2.499s2.499,3.754 2.499,6.033s-0.887,4.421 -2.499,6.033s-3.754,2.499 -6.033,2.499s-4.421,-0.887 -6.033,-2.499s-2.499,-3.754 -2.499,-6.033s0.887,-4.422 2.499,-6.033zm-356.676,-84.126c-3.326,3.325 -8.739,3.326 -12.067,-0.001c-3.327,-3.327 -3.327,-8.74 0,-12.066c1.664,-1.664 3.848,-2.495 6.034,-2.495c2.185,0 4.37,0.832 6.033,2.495c3.327,3.327 3.327,8.74 0,12.067zm194.37,18.529c-4.704,0 -8.532,-3.828 -8.532,-8.532c0,-4.704 3.827,-8.532 8.532,-8.532c4.705,0 8.532,3.828 8.532,8.532c0,4.704 -3.828,8.532 -8.532,8.532zm152.307,263.501c4.705,0 8.532,3.828 8.532,8.532c0,4.705 -3.828,8.532 -8.532,8.532c-4.704,0 -8.532,-3.828 -8.532,-8.532c-0.001,-4.705 3.827,-8.532 8.532,-8.532z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svg_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_6",
    fill: "#FFFFFF",
    d: "m408.914,471.829c-7.319,-7.32 -18.294,-8.781 -27.095,-4.422l-49.343,-49.344c-3.126,-3.125 -4.847,-7.281 -4.847,-11.701l0,-22.619l16.548,0c3.345,0 6.671,-0.42 9.886,-1.247c4.011,-1.032 6.426,-5.121 5.394,-9.133c-1.032,-4.011 -5.119,-6.426 -9.133,-5.394c-1.994,0.513 -4.062,0.773 -6.147,0.773l-176.354,0c-13.545,0 -24.564,-11.02 -24.564,-24.564l0,-176.354c0,-2.085 0.26,-4.153 0.773,-6.146c1.033,-4.011 -1.382,-8.1 -5.393,-9.133c-4.012,-1.033 -8.101,1.382 -9.133,5.393c-0.828,3.214 -1.247,6.54 -1.247,9.886l0,16.548l-66.395,0c-3.139,-9.308 -11.946,-16.032 -22.3,-16.032c-12.976,0 -23.532,10.556 -23.532,23.532c0,12.976 10.557,23.532 23.532,23.532c10.354,0 19.16,-6.724 22.3,-16.032l66.394,0l0,17.065l-32.581,0c-4.142,0 -7.5,3.358 -7.5,7.5c0,4.142 3.358,7.5 7.5,7.5l32.581,0l0,17.064l-120.758,0c-4.142,0 -7.5,3.358 -7.5,7.5c0,4.142 3.358,7.5 7.5,7.5l120.758,0l0,17.064l-32.581,0c-4.142,0 -7.5,3.358 -7.5,7.5c0,4.142 3.358,7.5 7.5,7.5l32.581,0l0,17.065l-22.62,0c-8.427,0 -16.35,3.281 -22.308,9.24l-49.326,49.326c-3.214,-1.601 -6.777,-2.453 -10.473,-2.453c-6.286,0 -12.195,2.448 -16.64,6.892c-4.443,4.445 -6.891,10.355 -6.891,16.64s2.448,12.195 6.893,16.64c4.444,4.445 10.354,6.892 16.64,6.892c6.286,0 12.195,-2.448 16.64,-6.892c4.445,-4.445 6.893,-10.354 6.893,-16.64c0,-3.696 -0.852,-7.259 -2.453,-10.473l49.326,-49.326c3.125,-3.125 7.281,-4.847 11.702,-4.847l22.62,0l0,16.548c0,21.816 17.749,39.564 39.564,39.564l16.548,0l0,66.394c-9.308,3.139 -16.032,11.946 -16.032,22.3c0,12.976 10.557,23.532 23.532,23.532s23.532,-10.557 23.532,-23.532c0,-10.354 -6.724,-19.16 -16.032,-22.3l0,-66.394l17.064,0l0,32.581c0,4.142 3.358,7.5 7.5,7.5c4.142,0 7.5,-3.358 7.5,-7.5l0,-32.581l17.063,0l0,120.76c0,4.142 3.358,7.5 7.5,7.5c4.142,0 7.5,-3.358 7.5,-7.5l0,-120.758l17.064,0l0,32.581c0,4.142 3.358,7.5 7.5,7.5c4.142,0 7.5,-3.358 7.5,-7.5l0,-32.581l17.064,0l0,22.619c0,8.427 3.282,16.35 9.241,22.308l49.343,49.343c-4.359,8.801 -2.898,19.775 4.422,27.095c4.587,4.588 10.614,6.881 16.64,6.881s12.053,-2.293 16.64,-6.881c9.175,-9.175 9.175,-24.104 0,-33.279zm-369.35,-271.425c-4.705,0 -8.532,-3.828 -8.532,-8.532c0,-4.705 3.828,-8.532 8.532,-8.532c4.704,0 8.532,3.828 8.532,8.532c0.001,4.705 -3.827,8.532 -8.532,8.532zm-9.999,197.904c-1.612,1.612 -3.754,2.499 -6.033,2.499s-4.421,-0.887 -6.033,-2.499s-2.499,-3.754 -2.499,-6.033s0.887,-4.421 2.499,-6.033s3.754,-2.499 6.033,-2.499s4.421,0.887 6.033,2.499s2.499,3.754 2.499,6.033s-0.887,4.422 -2.499,6.033zm170.838,74.129c0,4.704 -3.827,8.532 -8.532,8.532c-4.705,0 -8.532,-3.828 -8.532,-8.532c0,-4.704 3.828,-8.532 8.532,-8.532c4.704,0 8.532,3.828 8.532,8.532zm197.905,22.065c-3.327,3.327 -8.74,3.326 -12.067,0c-3.327,-3.327 -3.327,-8.74 0,-12.066c1.664,-1.663 3.849,-2.495 6.034,-2.495s4.37,0.832 6.033,2.495c3.326,3.326 3.326,8.739 0,12.066z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svg_10"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_11"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_12"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_13"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_14"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_15"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_16"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_17"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_18"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_19"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_20"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_21"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_22"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_23"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_24"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_95"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    transform: "matrix(0.9021276211284103,0,0,0.9021276211284103,-37.92143522080369,-36.565126832612805) ",
    id: "svg_29"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_30"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_31",
    fill: "#FFFFFF",
    d: "m414.429451,313.36323c-1.024,-8.201 -4.451,-14.732 -5.89,-17.181c1.041,-17.063 -2.342,-29.911 -10.059,-38.2c-6.016,-6.461 -13.044,-8.289 -16.613,-8.805c-5.443,-11.506 -14.696,-13.732 -20.32,-13.191c-10.53,-9.807 -20.27,-10.04 -26.689,-8.439c-4.233,1.058 -7.547,3.041 -9.603,4.536c-2.055,-1.497 -5.371,-3.478 -9.603,-4.536c-6.419,-1.604 -16.159,-1.37 -26.689,8.439c-5.63,-0.543 -14.879,1.685 -20.32,13.191c-3.569,0.515 -10.597,2.343 -16.613,8.805c-7.719,8.289 -11.1,21.137 -10.059,38.2c-1.439,2.447 -4.864,8.98 -5.89,17.181c-1.159,9.293 0.611,22.398 15.141,33.031c-1.684,9.94 -0.09,27.051 15.785,35.465c-0.659,3.616 -1.096,9.888 2.132,15.249c2.538,4.217 6.731,6.991 12.477,8.259c2.901,4.477 12.901,18.343 25.38,18.343c0.079,0 0.16,0 0.239,-0.002c6.69,-0.096 12.735,-4.05 18.019,-11.771c5.286,7.719 11.331,11.675 18.019,11.771c12.571,0.184 22.7,-13.836 25.62,-18.341c5.746,-1.268 9.94,-4.041 12.477,-8.259c3.229,-5.361 2.79,-11.634 2.132,-15.249c15.877,-8.414 17.471,-25.525 15.787,-35.465c14.531,-10.633 16.302,-23.737 15.14,-33.031zm-20.833,28.684c-1.2,0.8 -1.768,2.268 -1.418,3.668c0.232,0.928 5.451,22.794 -13.981,31.121c-1.633,0.7 -2.456,2.533 -1.894,4.217c0.024,0.073 2.325,7.38 -0.782,12.537c-1.684,2.799 -4.815,4.598 -9.3,5.345c-1,0.166 -1.874,0.77 -2.386,1.644c-2.669,4.555 -11.494,16.305 -20.325,16.305c-0.049,0 -0.101,0 -0.152,0c-5.311,-0.082 -10.373,-4.465 -15.044,-13.027c-0.599,-1.096 -1.877,-1.778 -3.127,-1.778s-2.398,0.681 -2.997,1.778c-4.669,8.562 -9.731,12.945 -15.044,13.027c-8.841,0.142 -17.792,-11.723 -20.477,-16.305c-0.512,-0.874 -1.388,-1.478 -2.386,-1.644c-4.471,-0.746 -7.595,-2.536 -9.283,-5.318c-3.145,-5.185 -0.818,-12.501 -0.797,-12.565c0.56,-1.684 -0.261,-3.517 -1.894,-4.217c-19.33,-8.284 -14.205,-30.199 -13.979,-31.121c0.35,-1.399 -0.218,-2.867 -1.418,-3.668c-25.464,-16.976 -9.318,-42.057 -8.622,-43.11c0.42,-0.63 0.618,-1.382 0.565,-2.137c-1.113,-15.563 1.603,-27.02 8.071,-34.057c6.219,-6.765 13.746,-6.939 14.041,-6.943c1.396,0 2.65,-0.85 3.169,-2.145c3.82,-9.547 9.958,-10.911 13.15,-10.911c1.027,0 1.751,0.142 1.99,0.198c1.164,0.29 2.393,-0.049 3.241,-0.898c6.946,-6.943 14.085,-9.61 21.22,-7.934c5.46,1.283 9.015,4.722 9.039,4.746c0.64,0.64 1.509,1 2.413,1l0.13,0c0.905,0 1.773,-0.36 2.413,-1c0.034,-0.034 3.468,-3.357 8.781,-4.685c7.219,-1.804 14.447,0.841 21.478,7.873c0.829,0.831 2.058,1.166 3.209,0.906c1.019,-0.234 10.122,-1.918 15.172,10.706c0.512,1.28 1.768,2.128 3.147,2.145c0.317,0.005 7.844,0.177 14.063,6.943c6.467,7.037 9.182,18.495 8.071,34.057c-0.053,0.754 0.145,1.507 0.565,2.137c0.044,0.065 4.35,6.607 5.434,15.275c1.413,11.309 -3.316,20.675 -14.056,27.835z"
  }))), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    transform: "matrix(0.9021276211284103,0,0,0.9021276211284103,-37.92143522080369,-36.565126832612805) ",
    id: "svg_32"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_33"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_34",
    fill: "#FFFFFF",
    d: "m382.653451,251.30823c-0.597,-1.789 -2.534,-2.753 -4.318,-2.159c-21.227,7.076 -21.472,24.815 -21.472,25.566c0,1.876 1.514,3.389 3.389,3.401c0.009,0 0.017,0 0.024,0c1.865,0 3.388,-1.512 3.413,-3.378c0.009,-0.555 0.377,-13.638 16.804,-19.113c1.789,-0.596 2.755,-2.528 2.16,-4.317z"
  }))), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    transform: "matrix(0.9021276211284103,0,0,0.9021276211284103,-37.92143522080369,-36.565126832612805) ",
    id: "svg_35"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_36"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_37",
    fill: "#FFFFFF",
    d: "m398.074451,342.81523c-1.143,-1.498 -3.282,-1.789 -4.784,-0.645c-5.562,4.238 -10.592,5.748 -14.94,4.495c-7.747,-2.231 -11.65,-12.435 -11.687,-12.539c-0.655,-1.765 -2.62,-2.668 -4.381,-2.012c-1.768,0.652 -2.673,2.616 -2.019,4.384c0.203,0.55 5.1,13.5 16.157,16.715c1.649,0.48 3.33,0.719 5.04,0.719c5.089,0 10.441,-2.118 15.969,-6.333c1.499,-1.142 1.787,-3.286 0.645,-4.784z"
  }))), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    transform: "matrix(0.9021276211284103,0,0,0.9021276211284103,-37.92143522080369,-36.565126832612805) ",
    id: "svg_38"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_39"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_40",
    fill: "#FFFFFF",
    d: "m340.363451,345.66223c-1.331,-1.333 -3.495,-1.333 -4.826,0c-1.333,1.333 -1.333,3.494 0,4.826c11.083,11.083 8.784,21.791 8.666,22.298c-0.444,1.823 0.667,3.662 2.488,4.118c0.276,0.068 0.555,0.102 0.829,0.102c1.529,0 2.922,-1.036 3.309,-2.587c0.151,-0.597 3.498,-14.793 -10.466,-28.757z"
  }))), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    transform: "matrix(0.9021276211284103,0,0,0.9021276211284103,-37.92143522080369,-36.565126832612805) ",
    id: "svg_41"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_42"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_43",
    fill: "#FFFFFF",
    d: "m393.321451,313.67423c-0.642,-1.768 -2.599,-2.683 -4.369,-2.046c-0.691,0.247 -16.966,5.938 -25.61,-5.567c-4.49,-5.975 -6.419,-11.092 -7.97,-15.203c-1.903,-5.043 -3.698,-9.808 -9.665,-10.3c-1.862,-0.157 -3.528,1.242 -3.681,3.121c-0.155,1.877 1.242,3.526 3.121,3.681c1.429,0.116 1.966,0.945 3.837,5.905c1.615,4.279 3.825,10.139 8.9,16.894c5.948,7.916 14.246,9.904 21.088,9.904c6.624,0 11.882,-1.865 12.315,-2.021c1.768,-0.645 2.676,-2.599 2.034,-4.368z"
  }))), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    transform: "matrix(0.9021276211284103,0,0,0.9021276211284103,-37.92143522080369,-36.565126832612805) ",
    id: "svg_44"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_45"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_46",
    fill: "#FFFFFF",
    d: "m325.191451,233.02723c-1.884,0 -3.413,1.529 -3.413,3.413l0,169.047c0,1.884 1.529,3.413 3.413,3.413c1.884,0 3.413,-1.527 3.413,-3.412l0,-169.048c0,-1.884 -1.529,-3.413 -3.413,-3.413z"
  }))), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    transform: "matrix(0.9021276211284103,0,0,0.9021276211284103,-37.92143522080369,-36.565126832612805) ",
    id: "svg_47"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_48"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_49",
    fill: "#FFFFFF",
    d: "m350.148451,262.43323c-0.027,-1.884 -1.521,-3.413 -3.463,-3.364c-1.886,0.027 -3.391,1.579 -3.364,3.463c0.003,0.213 0.189,21.495 -10.453,34.992c-1.167,1.481 -0.915,3.627 0.567,4.794c0.626,0.495 1.37,0.734 2.111,0.734c1.009,0 2.009,-0.445 2.681,-1.3c12.127,-15.378 11.934,-38.348 11.921,-39.319z"
  }))), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    transform: "matrix(0.9021276211284103,0,0,0.9021276211284103,-37.92143522080369,-36.565126832612805) ",
    id: "svg_50"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_51"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_52",
    fill: "#FFFFFF",
    d: "m357.087451,366.98823c-15.046,0 -22.084,20.594 -22.376,21.472c-0.596,1.787 0.369,3.715 2.156,4.314c0.358,0.121 0.724,0.177 1.082,0.177c1.427,0 2.758,-0.901 3.238,-2.33c1.572,-4.675 7.494,-16.807 15.901,-16.807c1.884,0 3.413,-1.529 3.413,-3.413s-1.53,-3.413 -3.414,-3.413z"
  }))), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    transform: "matrix(0.9021276211284103,0,0,0.9021276211284103,-37.92143522080369,-36.565126832612805) ",
    id: "svg_53"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_54"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_55",
    fill: "#FFFFFF",
    d: "m360.932451,235.45523c-1.509,-1.125 -3.649,-0.812 -4.775,0.701l-8.189,11.003c-1.125,1.51 -0.811,3.649 0.701,4.775c0.611,0.457 1.324,0.676 2.034,0.676c1.043,0 2.072,-0.474 2.741,-1.377l8.189,-11.003c1.125,-1.51 0.811,-3.648 -0.701,-4.775z"
  }))), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    transform: "matrix(0.9021276211284103,0,0,0.9021276211284103,-37.92143522080369,-36.565126832612805) ",
    id: "svg_56"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_57"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_58",
    fill: "#FFFFFF",
    d: "m291.053451,257.51623c-7.528,0 -13.653,6.125 -13.653,13.653c0,7.528 6.125,13.653 13.653,13.653s13.653,-6.125 13.653,-13.653c0,-7.528 -6.125,-13.653 -13.653,-13.653zm0,20.48c-3.765,0 -6.827,-3.062 -6.827,-6.827c0,-3.765 3.062,-6.827 6.827,-6.827c3.765,0 6.827,3.062 6.827,6.827c-0.001,3.765 -3.063,6.827 -6.827,6.827z"
  }))), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    transform: "matrix(0.9021276211284103,0,0,0.9021276211284103,-37.92143522080369,-36.565126832612805) ",
    id: "svg_59"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_60"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_61",
    fill: "#FFFFFF",
    d: "m267.159451,301.88923c-7.528,0 -13.653,6.125 -13.653,13.653c0,7.528 6.125,13.653 13.653,13.653c7.528,0 13.653,-6.125 13.653,-13.653c0.001,-7.528 -6.125,-13.653 -13.653,-13.653zm0,20.48c-3.765,0 -6.827,-3.062 -6.827,-6.827s3.062,-6.827 6.827,-6.827c3.765,0 6.827,3.062 6.827,6.827s-3.062,6.827 -6.827,6.827z"
  }))), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    transform: "matrix(0.9021276211284103,0,0,0.9021276211284103,-37.92143522080369,-36.565126832612805) ",
    id: "svg_62"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_63"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_64",
    fill: "#FFFFFF",
    d: "m301.293451,332.60923c-7.528,0 -13.653,6.125 -13.653,13.653c0,7.528 6.125,13.653 13.653,13.653c7.528,0 13.653,-6.125 13.653,-13.653c0,-7.528 -6.125,-13.653 -13.653,-13.653zm0,20.48c-3.765,0 -6.827,-3.062 -6.827,-6.827s3.062,-6.827 6.827,-6.827s6.827,3.062 6.827,6.827s-3.063,6.827 -6.827,6.827z"
  }))), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    transform: "matrix(0.9021276211284103,0,0,0.9021276211284103,-37.92143522080369,-36.565126832612805) ",
    id: "svg_65"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_66"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_67",
    fill: "#FFFFFF",
    d: "m301.293451,370.15623c-7.528,0 -13.653,6.125 -13.653,13.653c0,7.528 6.125,13.653 13.653,13.653c7.528,0 13.653,-6.125 13.653,-13.653c0,-7.528 -6.125,-13.653 -13.653,-13.653zm0,20.48c-3.765,0 -6.827,-3.062 -6.827,-6.827c0,-3.765 3.062,-6.827 6.827,-6.827s6.827,3.062 6.827,6.827c-0.001,3.765 -3.063,6.827 -6.827,6.827z"
  }))), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    transform: "matrix(0.9021276211284103,0,0,0.9021276211284103,-37.92143522080369,-36.565126832612805) ",
    id: "svg_68"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_69"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_70",
    fill: "#FFFFFF",
    d: "m291.053451,277.99623c-1.884,0 -3.413,1.529 -3.413,3.413l0,34.133c0,1.884 1.529,3.413 3.413,3.413c1.886,0 3.413,-1.527 3.413,-3.413l0,-34.133c0,-1.884 -1.529,-3.413 -3.413,-3.413z"
  }))), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    transform: "matrix(0.9021276211284103,0,0,0.9021276211284103,-37.92143522080369,-36.565126832612805) ",
    id: "svg_71"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_72"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_73",
    fill: "#FFFFFF",
    d: "m301.293451,312.12923l-23.894,0c-1.884,0 -3.413,1.529 -3.413,3.413c0,1.884 1.529,3.413 3.413,3.413l23.893,0c1.886,0 3.413,-1.529 3.413,-3.413c0.001,-1.884 -1.528,-3.413 -3.412,-3.413z"
  }))), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    transform: "matrix(0.9021276211284103,0,0,0.9021276211284103,-37.92143522080369,-36.565126832612805) ",
    id: "svg_74"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_75"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_76",
    fill: "#FFFFFF",
    d: "m301.293451,312.12923c-1.884,0 -3.413,1.529 -3.413,3.413l0,20.48c0,1.884 1.529,3.413 3.413,3.413c1.886,0 3.413,-1.527 3.413,-3.413l0,-20.48c0,-1.884 -1.529,-3.413 -3.413,-3.413z"
  }))), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    transform: "matrix(0.9021276211284103,0,0,0.9021276211284103,-37.92143522080369,-36.565126832612805) ",
    id: "svg_77"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_78"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_79",
    fill: "#FFFFFF",
    d: "m301.293451,353.08923c-1.884,0 -3.413,1.529 -3.413,3.413l0,17.067c0,1.884 1.529,3.413 3.413,3.413c1.886,0 3.413,-1.527 3.413,-3.413l0,-17.067c0,-1.884 -1.529,-3.413 -3.413,-3.413z"
  }))), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    transform: "matrix(0.9021276211284103,0,0,0.9021276211284103,-37.92143522080369,-36.565126832612805) ",
    id: "svg_80"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    transform: "matrix(0.9021276211284103,0,0,0.9021276211284103,-37.92143522080369,-36.565126832612805) ",
    id: "svg_81"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    transform: "matrix(0.9021276211284103,0,0,0.9021276211284103,-37.92143522080369,-36.565126832612805) ",
    id: "svg_82"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    transform: "matrix(0.9021276211284103,0,0,0.9021276211284103,-37.92143522080369,-36.565126832612805) ",
    id: "svg_83"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    transform: "matrix(0.9021276211284103,0,0,0.9021276211284103,-37.92143522080369,-36.565126832612805) ",
    id: "svg_84"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    transform: "matrix(0.9021276211284103,0,0,0.9021276211284103,-37.92143522080369,-36.565126832612805) ",
    id: "svg_85"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    transform: "matrix(0.9021276211284103,0,0,0.9021276211284103,-37.92143522080369,-36.565126832612805) ",
    id: "svg_86"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    transform: "matrix(0.9021276211284103,0,0,0.9021276211284103,-37.92143522080369,-36.565126832612805) ",
    id: "svg_87"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    transform: "matrix(0.9021276211284103,0,0,0.9021276211284103,-37.92143522080369,-36.565126832612805) ",
    id: "svg_88"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    transform: "matrix(0.9021276211284103,0,0,0.9021276211284103,-37.92143522080369,-36.565126832612805) ",
    id: "svg_89"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    transform: "matrix(0.9021276211284103,0,0,0.9021276211284103,-37.92143522080369,-36.565126832612805) ",
    id: "svg_90"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    transform: "matrix(0.9021276211284103,0,0,0.9021276211284103,-37.92143522080369,-36.565126832612805) ",
    id: "svg_91"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    transform: "matrix(0.9021276211284103,0,0,0.9021276211284103,-37.92143522080369,-36.565126832612805) ",
    id: "svg_92"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    transform: "matrix(0.9021276211284103,0,0,0.9021276211284103,-37.92143522080369,-36.565126832612805) ",
    id: "svg_93"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    transform: "matrix(0.9021276211284103,0,0,0.9021276211284103,-37.92143522080369,-36.565126832612805) ",
    id: "svg_94"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.91e3c6a6f6ee38547fc643adcb2bb7eb.svg";
export { ForwardRef as ReactComponent };